<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LId71d/tc-custom/9781473870840.jpg?1709187892306" alt="This image is the cover for the book Napoleon, France and Waterloo"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Napoleon, France and Waterloo
      </h1>
      <p class="bookDescription body article font2">
        <p>So great is the weight of reading on the subject of the Waterloo campaign that it might be thought there is nothing left to say about it, and from the military viewpoint, this is very much the case. But one critical aspect of the story has gone all but untold  the French home front. Little has been written about the topic in English, and few works on Napoleon or Revolutionary and Napoleonic France pay it much attention. It is this conspicuous gap in the literature that Charles Esdaile explores in this erudite and absorbing study.  Drawing on the vivid, revealing material that is available in the French archives, in the writings of soldiers who fought in France in 1814 and 1815 and in the memoirs of civilians who witnessed the fall of Napoleon or the Hundred Days, he gives us a fascinating new insight into the military and domestic context of the Waterloo campaign, the Napoleonic legend and the wider situation across Europe.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles Esdaile
      </h2>
      
      <p class="authorDescription body article">Professor Charles Esdaile is one of the leading historians of the Napoleonic era and holds a personal chair at the University of Liverpool. His wide-ranging history of Napoleon's attempt to conquer Spain and Portugal, The Peninsular War: A New History, and his international history of the Napoleonic period, Napoleons Wars, are classic works on the subject. Among his many other books are The French Wars 1792-1815, The Duke of Wellington and the Command of the Spanish Army 1812-14, Fighting Napoleon: Guerrillas, Bandits and Adventurers in Spain 1808-1814 and Peninsular Eyewitnesses: The Experience of War in Spain and Portugal 1808-1814.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?534648aa